import { inherits as _inherits, createSuper as _createSuper, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, typeof as _typeof, assertThisInitialized as _assertThisInitialized, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useThemeProps, Alert, AlertTitle } from '@mui/material';
import { ApiError } from '../../cinnamon-core/es/modules/api/errors.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _excluded = ["header", "error", "omitCodes", "overrideMessages", "className", "sx", "variant"];
var componentRoot = createComponentSlot({
  name: "CinErrorMessage",
  slot: "Root",
  skipForwardProps: ["fullWidth"]
});

var ErrorMessageBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorMessageBase, _React$Component);

  var _super = _createSuper(ErrorMessageBase);

  function ErrorMessageBase() {
    var _this;

    _classCallCheck(this, ErrorMessageBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isApiError", function (error) {
      return _typeof(error) === "object" && error instanceof ApiError;
    });

    _defineProperty(_assertThisInitialized(_this), "mapApiErrors", function (error) {
      var _this$props = _this.props,
          omitCodes = _this$props.omitCodes,
          overrideMessages = _this$props.overrideMessages;
      return error.format(omitCodes, overrideMessages);
    });

    _defineProperty(_assertThisInitialized(_this), "isGenericError", function (error) {
      return _typeof(error) === "object" && error.hasOwnProperty("message") && typeof error.message === "string";
    });

    _defineProperty(_assertThisInitialized(_this), "mapGenericErrors", function (error) {
      if (!error.message) return [];
      return [error.message];
    });

    return _this;
  }

  _createClass(ErrorMessageBase, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          header = _this$props2.header,
          error = _this$props2.error;
          _this$props2.omitCodes;
          _this$props2.overrideMessages;
          var className = _this$props2.className;
          _this$props2.sx;
          var variant = _this$props2.variant,
          otherProps = _objectWithoutProperties(_this$props2, _excluded);

      if (!error) return null;
      var errors = [];

      if (typeof error === "string" && error.length > 0) {
        errors = [error];
      } else if (this.isApiError(error)) {
        errors = this.mapApiErrors(error);
      } else if (this.isGenericError(error)) {
        errors = this.mapGenericErrors(error);
      }

      var content;

      if (!errors || errors.length === 0) {
        content = "An unexpected error has occurred";
      } else if (errors.length === 1) {
        content = errors[0];
      } else {
        content = /*#__PURE__*/React.createElement("ul", null, errors.map(function (e, i) {
          return /*#__PURE__*/React.createElement("li", {
            key: typeof e === "string" ? e : i
          }, e);
        }));
      } // fallback to standard if ErrorMessage variant is not supported by Alert


      var alertVariant = variant === "filled" || variant === "outlined" ? variant : "standard";
      return /*#__PURE__*/React.createElement(Alert, _extends({
        severity: "error"
      }, otherProps, {
        className: classnames(componentRoot.className, className),
        variant: alertVariant
      }), header && /*#__PURE__*/React.createElement(AlertTitle, null, header), content);
    }
  }]);

  return ErrorMessageBase;
}(React.Component);

_defineProperty(ErrorMessageBase, "propTypes", {
  header: propTypes.string,
  error: propTypes.oneOfType([propTypes.any, propTypes.shape({
    message: propTypes.string
  }), propTypes.string]),
  omitCodes: propTypes.bool,
  overrideMessages: propTypes.any,
  fullWidth: propTypes.bool,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
});

var ErrorMessageRoot = styled(ErrorMessageBase, componentRoot.styledOptions)(function (_ref) {
  var fullWidth = _ref.fullWidth;
  return {
    width: fullWidth ? "100%" : undefined
  };
});
ErrorMessageRoot.defaultProps = {
  header: "Something went wrong",
  omitCodes: false,
  variant: "standard"
};
/**
 * Component for rendering an API error message
 */

var ErrorMessage = function ErrorMessage(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(ErrorMessageRoot, rootProps);
};

var ErrorMessage$1 = ErrorMessage;

export { ErrorMessage$1 as default };
